import React from "react";
import PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    streamlineIcon: {
        color: theme.palette.grey[400],
        fill: "currentColor",
        stroke: "currentColor",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fontSize: theme.spacing(3),
        flexShrink: 0,
        userSelect: "none",

        "& svg path": {
            stroke: "currentColor"
        }
    }
}));

const StreamlineIcon = ({
    width,
    height,
    size,
    className,
    ariaLabel,
    e2eId,
    onClick,
    children
}) => {
    const initialWidth = 24;
    const initialHeight = 24;
    const classes = useStyles();

    const getClassName = () => {
        const classNames = [classes.streamlineIcon];
        if (className) {
            classNames.push(className);
        }

        return classNames.join(" ");
    };

    let resizeWidth = 1;
    let resizeHeight = 1;

    if (size) {
        resizeWidth = size / initialWidth;
        resizeHeight = size / initialHeight;
    } else {
        if (width && width !== initialWidth) {
            resizeWidth = initialWidth / width;
        }

        if (height && height !== initialHeight) {
            resizeHeight = initialHeight / height;
        }
    }

    return (
        <i
            className={getClassName()}
            aria-label={ariaLabel}
            onClick={onClick}
            e2e-id={e2eId}
        >
            {children &&
                (resizeWidth !== 1 || resizeHeight !== 1) ? (
                    <svg
                        viewBox={`0 0 ${resizeWidth * initialWidth} ${resizeHeight * initialHeight}`}
                        width={resizeWidth * initialWidth}
                        height={resizeHeight * initialHeight}
                    >
                        <g transform={`scale(${resizeWidth},${resizeHeight})`} >
                            {children}
                        </g>
                    </svg>
                ) : (
                    <svg viewBox={`0 0 ${initialWidth} ${initialHeight}`}>
                        {children}
                    </svg>
                )
            }
        </i>
    );
};

StreamlineIcon.defaultProps = {

};

StreamlineIcon.propTypes = {
    size: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
    e2eId: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.element
};

export default StreamlineIcon;
